<template>
  <div class="input-wrapper">
    <textarea
      :class="['custom-input', className]"
      @input="handleInput"
      :disabled="disabled"
      :value="modelValue"
      :rows="rows"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  className: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ""
  },
  rows: {
    type: [String, Number],
    default: 2,
  },
});

const emit = defineEmits(['update:modelValue']);

const handleInput = (event) => {
  console.log('Textarea value:', event.target.value);
  emit('update:modelValue', event.target.value);
};
</script>

<style scoped>
.input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}

.custom-input {
  width: 100%;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #22282b;
  line-height: 22.54px;
  border-radius: 20px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  background-color: #f6f6f6;
  resize: vertical;
}

.custom-input:focus {
  outline: none;
  border-color: #3182ce;
}

.custom-input::placeholder {
  color: #22282b;
}

.custom-input:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
  border-color: #bdbdbd;
}
</style>
